/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="74.97"
        height="95.59"
        viewBox="0 0 74.97 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="m72.55.81 2.34.88-10.6 28a1.25 1.25 0 0 1-1 .81H11.84a1.26 1.26 0 0 1-1.11-.69l-.06-.12-10.59-28L2.42.81 12.68 28h49.55Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M73.68 0H1.25A1.24 1.24 0 0 0 0 1.25v93.04a1.24 1.24 0 0 0 1.25 1.25h72.43a1.24 1.24 0 0 0 1.25-1.25v-93A1.24 1.24 0 0 0 73.68 0Zm-1.25 2.5v90.58h-70V2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M38.48 15.5v32.13h-2V15.5h2z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M36.38 22.6a5.65 5.65 0 1 0-4.44-6.65 5.87 5.87 0 0 0 0 2.21 5.67 5.67 0 0 0 4.44 4.44"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M31.82 18.19a6 6 0 1 0 0-.23Zm6.74-6.55a5.51 5.51 0 1 1-2.19 0 5.39 5.39 0 0 1 2.19 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M36.38 53.39A5.65 5.65 0 1 0 31.94 49a5.67 5.67 0 0 0 4.44 4.39"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M31.82 49a6 6 0 1 0 0-.22Zm6.74-6.56a5.5 5.5 0 1 1-2.16 0 5.42 5.42 0 0 1 2.16 0Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'InnerOfficeEnvelopeFastenedWithStringIcon';

export default Icon;
